/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import router from "@/router";
import axios from "axios";
import { API_SING_IN } from "@/constants/api";

export default {
  loginAttempt({ dispatch }, payload) {
    const newPayload = {
      userDetails: payload.userDetails,
      notify: payload.notify,
      vm: payload.vm
    };
    dispatch("login", payload);
  },

  login({ commit, state }, payload) {
    let formData = new FormData();
    formData.append("user[login]", payload.userDetails.email);
    formData.append("user[password]", payload.userDetails.password);
    const url = API_SING_IN();
    axios
      .post(url, formData)
      .then(response => {
        commit("UPDATE_AUTHENTICATED_USER", {
          userInfo: response.data,
          accessToken: response.data.authentication_token
        });
        // console.log("response", response.data);
        const { roles_mask } = response.data;

        payload.vm.$acl.change(roles_mask ? "ROLE_SYSADMIN" : "ROLE_EDITOR");
        router.push(router.currentRoute.query.to || "/");
      })
      .catch(error => {
        payload.notify({
          time: 2500,
          title: "ผิดพลาด!",
          text: "Username หรือ Password ไม่ถูกต้อง กรุณาตรวจสอบใหม่!",
          iconPack: "feather",
          icon: "icon-alert-circle",
          position: "top-center",
          color: "danger"
        });
      });
  },

  updateAuthenticatedUser({ commit }, payload) {
    commit("UPDATE_AUTHENTICATED_USER", payload);
  },

  updateAuthenticatedUserToken({ commit }, payload) {
    commit("UPDATE_AUTHENTICATED_USER_TOKEN", payload);
  }
};
